import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1b282404"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comment-changed-modal__header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "heading-level-3" }, "edited Comment", -1))
const _hoisted_3 = { class: "comment-changed-modal__body" }
const _hoisted_4 = { class: "comment-changed-modal__column" }
const _hoisted_5 = { class: "comment-changed-modal__card" }
const _hoisted_6 = { class: "custom-scroll comment-changed-modal__card__content" }
const _hoisted_7 = {
  key: 1,
  class: "comment-changed-modal__box"
}
const _hoisted_8 = { class: "comment-changed-modal__footer" }
const _hoisted_9 = { class: "comment-changed-modal__actions" }
const _hoisted_10 = { class: "comment-changed-modal__info" }
const _hoisted_11 = { class: "comment-changed-modal__column" }
const _hoisted_12 = { class: "comment-changed-modal__card" }
const _hoisted_13 = { class: "custom-scroll comment-changed-modal__card__content" }
const _hoisted_14 = {
  key: 1,
  class: "comment-changed-modal__box"
}
const _hoisted_15 = { class: "comment-changed-modal__footer" }
const _hoisted_16 = { class: "comment-changed-modal__actions" }
const _hoisted_17 = { class: "comment-changed-modal__info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseHeading = _resolveComponent("BaseHeading")!
  const _component_CommentOwner = _resolveComponent("CommentOwner")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_FileCommentItem = _resolveComponent("FileCommentItem")!
  const _component_CommentHistoryContent = _resolveComponent("CommentHistoryContent")!
  const _component_ReactionList = _resolveComponent("ReactionList")!
  const _component_ControlButtons = _resolveComponent("ControlButtons")!
  const _component_CustomModal = _resolveComponent("CustomModal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_CustomModal, {
    id: `comment-changed-${_ctx.comment.id}`,
    modalClass: "comment-changed-modal",
    width: "75%"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_CommentOwner, {
          user: _ctx.comment.owner,
          userNameWeight: "400"
        }, {
          username: _withCtx(({ userName }) => [
            _createVNode(_component_BaseHeading, { level: "4" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(userName) + " ", 1),
                _hoisted_2
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["user"]),
        _createVNode(_component_BaseSubHeading, {
          size: "large",
          weight: "400",
          color: "monochrome-05",
          darkColor: "monochrome-04"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.comment.timeAndDateReversed), 1)
          ]),
          _: 1
        })
      ])
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_BaseHeading, {
            class: "comment-changed-modal__label",
            level: "4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Before: ")
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.mediaFilesBefore?.length)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "comment-changed-modal__files",
                    style: _normalizeStyle(_ctx.mediaFilesBefore.length === 1 ? { 'max-width': '260px' } : {})
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mediaFilesBefore, (item) => {
                      return (_openBlock(), _createBlock(_component_FileCommentItem, {
                        key: item.id,
                        item: item,
                        isRemoved: item.deleted,
                        projectScoped: _ctx.projectScoped
                      }, null, 8, ["item", "isRemoved", "projectScoped"]))
                    }), 128))
                  ], 4))
                : _createCommentVNode("", true),
              (_ctx.before)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_CommentHistoryContent, {
                      comment: _ctx.before,
                      comments: [],
                      demoVideoId: _ctx.comment.demoVideoId,
                      demoVideoVersionMap: _ctx.demoVideoVersionMap,
                      projectScoped: _ctx.projectScoped
                    }, null, 8, ["comment", "demoVideoId", "demoVideoVersionMap", "projectScoped"]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_ReactionList, {
                          reactions: _ctx.before.reactionsWithUserPreviews,
                          myReactionType: _ctx.myReactionTypeBefore
                        }, null, 8, ["reactions", "myReactionType"])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _withDirectives((_openBlock(), _createBlock(_component_BaseSubHeading, {
                          size: "small",
                          weight: "400",
                          color: "monochrome-05",
                          darkColor: "monochrome-04",
                          class: "comment-changed-modal__date"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.comment.timeAgo), 1)
                          ]),
                          _: 1
                        })), [
                          [
                            _directive_tooltip,
                            { content: _ctx.comment.timeAndDate, theme: 'info-tooltip' },
                            void 0,
                            { bottom: true }
                          ]
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_BaseHeading, {
            class: "comment-changed-modal__label",
            level: "4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" After: ")
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              (_ctx.mediaFilesAfter?.length)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "comment-changed-modal__files",
                    style: _normalizeStyle(_ctx.mediaFilesAfter.length === 1 ? { 'max-width': '260px' } : {})
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mediaFilesAfter, (item) => {
                      return (_openBlock(), _createBlock(_component_FileCommentItem, {
                        key: item.id,
                        item: item,
                        isRemoved: item.deleted,
                        projectScoped: _ctx.projectScoped
                      }, null, 8, ["item", "isRemoved", "projectScoped"]))
                    }), 128))
                  ], 4))
                : _createCommentVNode("", true),
              (_ctx.after)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_component_CommentHistoryContent, {
                      comment: _ctx.after,
                      comments: [],
                      demoVideoId: _ctx.comment.demoVideoId,
                      demoVideoVersionMap: _ctx.demoVideoVersionMap,
                      projectScoped: _ctx.projectScoped
                    }, null, 8, ["comment", "demoVideoId", "demoVideoVersionMap", "projectScoped"]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_ReactionList, {
                          reactions: _ctx.after.reactionsWithUserPreviews,
                          myReactionType: _ctx.myReactionTypeAfter
                        }, null, 8, ["reactions", "myReactionType"])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _withDirectives((_openBlock(), _createBlock(_component_BaseSubHeading, {
                          size: "small",
                          weight: "400",
                          color: "monochrome-05",
                          darkColor: "monochrome-04",
                          class: "comment-changed-modal__date"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.comment.timeAgo), 1)
                          ]),
                          _: 1
                        })), [
                          [
                            _directive_tooltip,
                            { content: _ctx.comment.timeAndDate, theme: 'info-tooltip' },
                            void 0,
                            { bottom: true }
                          ]
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    footer: _withCtx(({ hide }) => [
      _createVNode(_component_ControlButtons, {
        hideCancel: true,
        onSave: hide
      }, {
        save: _withCtx(() => [
          _createTextVNode(" Ok ")
        ]),
        _: 2
      }, 1032, ["onSave"])
    ]),
    _: 1
  }, 8, ["id"]))
}